module.exports = __webpack_public_path__ + "static/media/blogsImage.058eca4c.svg";